import { $isDecoratorBlockNode } from "@lexical/react/LexicalDecoratorBlockNode";
import { $getSelection, $isElementNode } from "lexical";

export const $multipleElementsSelected = (): boolean => {
  const selection = $getSelection();
  if (!selection) return false;

  return (
    selection.getNodes().filter((x) => $isElementNode(x) || $isDecoratorBlockNode(x)).length > 1
  );
};
